export interface RollingWindowResult<T> {
  retained: T[];
  removed: T[];
}

/**
 * Returns the newest items up to the provided limit and the items that need to be purged.
 * The input array is not mutated.
 */
export function trimByLimit<T>(entries: T[], limit: number): RollingWindowResult<T> {
  if (limit <= 0) {
    return { retained: [], removed: [...entries] };
  }
  if (entries.length <= limit) {
    return { retained: [...entries], removed: [] };
  }
  const overflow = entries.length - limit;
  return {
    removed: entries.slice(0, overflow),
    retained: entries.slice(overflow)
  };
}
